


export class BrowserAppEvaluationToolInfo {

  public version = '2024.5.28.1';

  constructor() {
  }

}
